import { render, staticRenderFns } from "./Salidainv.vue?vue&type=template&id=0781f54a&"
import script from "./Salidainv.vue?vue&type=script&lang=js&"
export * from "./Salidainv.vue?vue&type=script&lang=js&"
import style0 from "./Salidainv.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports